<template>
  <div class="recommend">
    <h4>
      Product Recommendation
      <span @click="$router.push('/exhibitor')">more ></span>
    </h4>
    <div class="wrapper" ref="wrapper">
      <ul class="recommendList" ref="ulWidth">
        <li v-for="(item,i) in list" :key="i" @click="$router.push('/exhibit/details/'+item.id+'/'+item.ocid)">
          <div>
            <img :src="item.img_url" alt=""/>
          </div>
          <p>{{item.proname_en}}</p>
        </li>
      </ul>
    </div>
    
  </div>
</template>

<script>
import { reqProListAd } from "../../../api";
export default {
  data () {
    return {
      list:[]
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(){
      const response = await reqProListAd()
      if (response.code*1==1) {
        this.list = response.resilt
      }
    },
  }
}
</script>

<style scoped>
.wrapper{
  overflow: hidden;
  width: 100%;
}
.recommendList{
  height: 150px;
  white-space: nowrap;
  overflow-x: auto;
}
.recommendList li{
  display: inline-block;
  width: 90px;
  margin: 0 10px;
  text-align: center;
  vertical-align: top;
}
.recommendList li:first-child{
  margin-left: 0;
}
.recommendList li div{
  width: 90px;
  height: 90px;
  overflow: hidden;
  box-shadow: 3px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  background-color: white;
}
.recommendList li p{
  white-space:pre-wrap;
  margin-top: 10px;
  padding:0 2px;
  line-height: 20px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

</style>